import React, { useState, useEffect } from "react"
import "./ReadAndWriteTable.scss"
import { UpdateFormTemplateReadWrite, getFormReadAndWriteByType } from "core/services/api/masterService"
import Button from "react-bootstrap/esm/Button"
import Toast from "components/Toast"
import { useParams } from "react-router"
import { getAllStaffRoles } from "core/services/api/adminService"

function ReadAndWriteTable(formTemplate: any) {
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { id } = useParams<{ id: string }>()

  const initialData = [
    {
      subType: "Radiology Advice Vile Parle",
      readRights: [
        "FRONT_DESK",
      ],
      writeRights: ["NURSE"],
    },
    {
      subType: "Chemotherapy Consent Form",
      readRights: [
        "RMO",
        "CONSULTANT",
        "INSURANCE",
        "GENETIC_COUNSELLOR",
        "PHYSIOTHERAPIST",
        "NUTRITIONIST",
      ],
      writeRights: [
        "NURSE",
        "GENETIC_COUNSELLOR",
        "PHYSIOTHERAPIST",
        "NUTRITIONIST",
        "RMO",
        "CONSULTANT",
      ],
    },
    {
      subType: "Consent Form for Special Procedure",
      readRights: [
        "FRONT_DESK",
        "NURSE",
        "RMO",
        "CONSULTANT",
        "INSURANCE",
        "GENETIC_COUNSELLOR",
        "PHYSIOTHERAPIST",
        "NUTRITIONIST",
      ],
      writeRights: [
        "INSURANCE",
        "GENETIC_COUNSELLOR",
        "PHYSIOTHERAPIST",
        "NUTRITIONIST",
        "CONSULTANT",
      ],
    },
    {
      subType: "Blood Transfusion Monitoring Form",
      readRights: ["PHYSIOTHERAPIST", "NUTRITIONIST"],
      writeRights: ["NURSE", "RMO"],
    },
    {
      subType: "Homecare Advice",
      readRights: ["CONSULTANT", "INSURANCE"],
      writeRights: ["GENETIC_COUNSELLOR", "PHYSIOTHERAPIST", "NUTRITIONIST"],
    },
  ]

  // roles to remove
  const rolesToRemove = [
    "ACCOUNTANT",
    "OPERATIONS",
    "MANAGEMENT",
    "MARKETING",
    "CLINICAL_RESEARCH",
    "QUALITY",
    "INSURANCE"
  ];
  const [headers, setHeaders] = useState<any>()
  useEffect(() => {
    setCurrentFormTemplateType(formTemplate?.formTemplate?.type)
    getAllStaffRoles().then((res: any) => {
      const filteredRolesArray = res?.filter((role: any) => !rolesToRemove.includes(role));
      setHeaders(filteredRolesArray);
    }).catch((err: any) => {
      console.log(err)
    })
  }, [])

  const [currentFormTemplateType, setCurrentFormTemplateType] = useState<any>('COMMON')
  useEffect(() => {
    if (currentFormTemplateType) {
      getFormReadAndWriteByType(currentFormTemplateType)
        .then((res) => {
          console.log(data, "data");
          setData(res)
        })
        .catch((err) => {

          console.log("err", err)
        })
    }
  }, [currentFormTemplateType])



  // function to handle checkbox state change for read access
  const [data, setData] = useState<any>(initialData);
  console.log(data, "data");
  // const handleReadAccessChange = (key: any, header: any, checked: any) => {
  //   setData((prevData: any) => {
  //     const updatedData = prevData.map((item: any) => {
  //       if (item === key) {
  //         const readRights = item.readRights;
  //         if (checked && !readRights?.includes(header)) {
  //           item.readRights = [...readRights, header];
  //         } else if (!checked && readRights?.includes(header)) {
  //           item.readRights = readRights?.filter((item: any) => item !== header);
  //         }
  //       }
  //       return item;
  //     });
  //     console.log(updatedData, "updated Data for Read");
  //     return updatedData;
  //   });
  // };
  const handleReadAccessChange = (key: any, header: any, checked: any) => {
    setData((prevData: any) => {
      const updatedData = prevData.map((item: any) => {
        if (item === key) {
          const readRights = item.readRights || []; // Assign an empty array if readRights is null
          if (checked && !readRights.includes(header)) {
            item.readRights = [...readRights, header];
          } else if (!checked && readRights.includes(header)) {
            item.readRights = readRights.filter((item: any) => item !== header);
          }
        }
        return item;
      });
      console.log(updatedData, "updated Data for Read");
      return updatedData;
    });
  };

  //function to handle Write change access
  const handleWriteAccessChange = (key: any, header: any, checked: any) => {
    setData((prevData: any) => {
      const updatedData = prevData.map((item: any) => {
        if (item === key) {
          const writeRights = item.writeRights || [];
          if (checked && !writeRights.includes(header)) {
            item.writeRights = [...writeRights, header];
          } else if (!checked && writeRights.includes(header)) {
            item.writeRights = writeRights.filter((item: any) => item !== header);
          }
        }

        return item;
      });
      console.log(updatedData, "Write")
      return updatedData;
    });
  };

  //Read Access Component
  const ReadAccess = ({ checked, onChange }: any) => {
    return (
      <td>
        <label style={{ display: 'flex', columnGap: '5px' }}>
          <input
            className="input-checkbox"
            type="checkbox"
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
          />
          <strong>R</strong>
        </label>
      </td>
    );
  };

  //Write Access Component
  const WriteAccess = ({ checked, onChange }: any) => {
    return (
      <td>
        <label style={{ display: 'flex', columnGap: '5px' }}>
          <input
            className="input-checkbox"
            type="checkbox"
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
          />
          <strong>W</strong>
        </label>
      </td>
    );
  };

  //handle Updation
  const handleUpdate = (() => {
    const form = data?.find((key: any) => key.id === id)
    delete form["id"]

    UpdateFormTemplateReadWrite(id, form)
      .then((res) => {
        setIsLoading(false)
        toggleDisplayToast({ text: "Read and Write Access Updated Successfully", type: "success" })
      })
      .catch((err) => {
        setIsLoading(false)
        toggleDisplayToast({ text: `Error in Updating Details`, type: "error" })
        console.log("err", err)
      })
  })


  return (
    <div className="read-write-container">
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>
      )}
      <div className="style-table-div">

        <table className="styled-table">
          <thead>
            <tr>
              <th>Forms</th>
              {headers?.map(
                (item: any, index: any) => {
                  return (
                    <>
                      <th>{item}</th>
                    </>
                  )
                }
              )}
            </tr>
          </thead>

          <tbody>
            {data?.filter((key: any) => key.id === id)?.map((key: any) => (
              <tr>
                <td><strong>{key?.subType}</strong></td>
                {headers?.map((header: any) => (
                  <td key={header}>
                    <span className="Read-Write">

                      <ReadAccess
                        checked={key?.readRights?.includes(header)}
                        onChange={(checked: any) =>
                          handleReadAccessChange(key, header, checked)
                        }
                      />
                      <WriteAccess
                        checked={key?.writeRights?.includes(header)}
                        onChange={(checked: any) =>
                          handleWriteAccessChange(key, header, checked)
                        }
                      />
                    </span>
                  </td>
                ))}
              </tr>
            ))}

          </tbody>

        </table>

      </div>
      <div className="header-read">
        <div className="edit-heading"></div>
        <div>
          <Button
            style={{ height: "40px" }}
            onClick={() => handleUpdate()}

          >
            Update
          </Button>
        </div>
      </div>

      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              window.location.reload();
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div>
  )
}

export default ReadAndWriteTable

